import { render, staticRenderFns } from "./admin-sidebar.html?vue&type=template&id=2b0bc715&scoped=true&"
import script from "./admin-sidebar.js?vue&type=script&lang=js&"
export * from "./admin-sidebar.js?vue&type=script&lang=js&"
import style0 from "./admin-sidebar.scss?vue&type=style&index=0&id=2b0bc715&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bc715",
  null
  
)

export default component.exports